<script setup lang="ts">
  import type { ProductFlexibleResource } from '@storefront/resources';

  interface Props {
    product: ProductFlexibleResource,
    disabled: boolean,
  }

  defineProps<Props>();
</script>
<template>
  <div class="flexible-extras" :class="{ disabled }" :aria-disabled="disabled" :inert="disabled">
    <ShopProductViewConfiguratorExtra v-for="(extra, index) in product.flexibleExtras" :extra="extra" :product="product" :index="index" />
  </div>
</template>
<style scoped lang="scss">
  .flexible-extras {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
</style>
